
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" id="home">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/4828a0baef599d9c2646684fc53b8c3a.jpeg"
          alt="Dental Implants Chelmsford Essex - Beaulieu Dental"
          title="Dental Implants Chelmsford Essex | All on 4 | Smile in a Day"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
          <strong>Dental Implants in Chelmsford Essex</strong><br />Life-Changing Tooth Replacement<br />All on 4 & Smile in a Day
        </h1>
        
        <p className="text-lg md:text-xl text-white/90 mb-6 max-w-3xl mx-auto">
          Expert <strong>Dental Implant Specialist</strong> in Chelmsford offering <strong>All on 4</strong>, <strong>All on X</strong>, and <strong>Smile in a Day</strong> solutions at Beaulieu Dental
        </p>

        <p className="text-base text-white/95 mb-10 max-w-4xl mx-auto">
          Replace missing teeth with advanced <strong>dental implants in Essex</strong> led by <strong>Dr. Yasir Saeed, Principal Dentist</strong> with 30+ years of experience. Our <strong>private dentist in Chelmsford</strong> specializes in caring for <strong>anxious dental patients</strong> with gentle, patient-centered treatment.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <button
            onClick={() => {
              const element = document.getElementById('booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#D0A24F] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#F5d383] transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Book Your FREE Implant Consultation Today
          </button>
          <a
            href="tel:01245465586"
            className="bg-white text-[#444c42] px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Call 01245 465586
          </a>
        </div>

        <button
          onClick={() => {
            const element = document.getElementById('cost-finance');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }}
          className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all shadow-lg whitespace-nowrap cursor-pointer"
        >
          0% Finance Plans Available
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
